/* ══════════════════════════════════════════════════════════════════════
   MAGAZINE — "Look inside" page-turn carousel behaviour.

   A port of the book half of assets/tws-ap.js, with mgl- ids and NOTHING
   else. In particular it does NOT carry that file's entrance-reveal
   observer: on a magazine page tws-mg.js already reveals `[data-mg]
   [data-rv]`, and a second observer would animate every section twice.

   The <img> list inside .mgl-src IS the content. The book is built from
   it and .mgl-live is only added once the book is standing, so a page
   where this script never runs still shows every page, stacked.
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  if (window.__twsMglInit) return;
  window.__twsMglInit = 1;

  function initBook() {
    var host = document.getElementById('mglBook');
    var stage = document.getElementById('mglStage');
    var lane = document.getElementById('mglLeaves');
    var prev = document.getElementById('mglPrev');
    var next = document.getElementById('mglNext');
    var count = document.getElementById('mglCount');
    if (!host || !stage || !lane) return;
    if (host.getAttribute('data-mgl-built')) return;
    host.setAttribute('data-mgl-built', '1');

    var src = Array.prototype.slice.call(host.querySelectorAll('.mgl-src img'));
    var N = src.length;
    if (!N) { var sec = host.closest('section'); if (sec) sec.style.display = 'none'; return; }

    var pages = src.map(function (im) {
      return { src: im.currentSrc || im.src, alt: im.alt || '' };
    });

    /* Give the pane the pages' OWN aspect ratio.
       ⚠ Read the width/height ATTRIBUTES, not naturalWidth. The source list
       is lazy-loaded and gets display:none the moment the book takes over,
       so those images may never decode — naturalWidth stays 0 and `load`
       never fires. The attributes are always there. */
    var bkEl = document.getElementById('mglBk');
    function setRatio() {
      var im = src[0];
      if (!im || !bkEl) return;
      var w = parseFloat(im.getAttribute('width')) || im.naturalWidth;
      var h = parseFloat(im.getAttribute('height')) || im.naturalHeight;
      if (!w || !h) return;
      bkEl.style.setProperty('--pg', w + ' / ' + h);
    }
    setRatio();
    if (src[0]) src[0].addEventListener('load', setRatio, { once: true });

    var wide = matchMedia('(min-width:760px)');
    var mode, leaves, tMax, t = 0;

    function face(cls, page) {
      if (!page) return '<div class="' + cls + '"><span class="mgl-leaf-img mgl-leaf-blank"></span><span class="mgl-leaf-shade" aria-hidden="true"></span></div>';
      return '<div class="' + cls + '"><span class="mgl-leaf-img"><img src="' + page.src +
        '" alt="' + String(page.alt).replace(/"/g, '&quot;') + '" loading="lazy" decoding="async"></span>' +
        '<span class="mgl-leaf-shade" aria-hidden="true"></span></div>';
    }

    /* spread (>=760)  leaf j: front = img[2j], back = img[2j+1] — the flipped
                       leaf's BACK becomes the left page, so every image is seen.
       single (<760)   leaf j: front = img[j], back = img[j+1] — the back carries
                       the NEXT image rather than blank paper, so the turning
                       page arrives showing what leaf j+1 reveals underneath it. */
    function build(keepImg) {
      mode = wide.matches ? 'spread' : 'single';
      var html = '<span class="mgl-bind" aria-hidden="true"></span>';
      var L, j;
      if (mode === 'spread') {
        L = Math.ceil(N / 2);
        for (j = 0; j < L; j++) {
          html += '<div class="mgl-leaf" data-j="' + j + '">' +
            face('mgl-leaf-f', pages[2 * j]) + face('mgl-leaf-b', pages[2 * j + 1]) + '</div>';
        }
        tMax = Math.floor(N / 2);
      } else {
        L = N;
        for (j = 0; j < L; j++) {
          html += '<div class="mgl-leaf" data-j="' + j + '">' +
            face('mgl-leaf-f', pages[j]) + face('mgl-leaf-b', pages[j + 1]) + '</div>';
        }
        tMax = N - 1;
      }
      lane.innerHTML = html;
      leaves = Array.prototype.slice.call(lane.querySelectorAll('.mgl-leaf'));
      var idx = keepImg || 0;
      t = mode === 'spread' ? (idx <= 0 ? 0 : Math.min(tMax, Math.floor((idx + 1) / 2))) : Math.min(tMax, idx);
      paint();
    }

    function firstVisibleImg() {
      if (mode === 'spread') return t === 0 ? 0 : 2 * t - 1;
      return t;
    }

    function label() {
      if (mode === 'single') return (t + 1) + ' / ' + N;
      if (t === 0) return '1 / ' + N;
      var l = 2 * t, r = 2 * t + 1;
      return (r <= N ? l + '–' + r : '' + l) + ' / ' + N;
    }

    function paint(moved) {
      var total = leaves.length;
      leaves.forEach(function (el, i) {
        var flipped = i < t;
        el.classList.toggle('flipped', flipped);
        el.style.zIndex = flipped ? String(10 + i) : String(10 + (total - i));
        el.setAttribute('aria-hidden', i === t ? 'false' : 'true');
      });
      if (moved !== undefined && leaves[moved]) leaves[moved].style.zIndex = '60';
      if (count) count.textContent = label();
      if (prev) prev.disabled = t === 0;
      if (next) next.disabled = t >= tMax;
    }

    function syncMode() {
      var want = wide.matches ? 'spread' : 'single';
      if (want !== mode) build(firstVisibleImg());
    }

    function go(dir) {
      /* Re-derive the layout before moving. resize / matchMedia /
         ResizeObserver are all wired below, but none of them is guaranteed
         to be delivered by every renderer — reading the state at the moment
         it matters is the one check that cannot be skipped. */
      syncMode();
      var target = t + dir;
      if (target < 0 || target > tMax) return;   // hard stop at the last image
      var moved = dir > 0 ? t : target;
      t = target;
      paint(moved);
    }

    build(0);
    host.classList.add('mgl-live');

    if (next) next.addEventListener('click', function () { go(1); });
    if (prev) prev.addEventListener('click', function () { go(-1); });

    addEventListener('keydown', function (e) {
      var r = stage.getBoundingClientRect();
      if (r.bottom < 0 || r.top > innerHeight) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });

    var sx = 0, sy = 0, live = false;
    function down(e) {
      var p = e.touches ? e.touches[0] : e;
      sx = p.clientX; sy = p.clientY; live = true;
    }
    function up(e) {
      if (!live) return;
      live = false;
      var p = (e.changedTouches && e.changedTouches[0]) || e;
      var dx = p.clientX - sx, dy = p.clientY - sy;
      if (Math.abs(dx) < 36 || Math.abs(dx) < Math.abs(dy)) {
        // a tap, not a swipe: on the spread, the left page goes back
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) {
          var box = stage.getBoundingClientRect();
          go(mode === 'spread' && p.clientX < box.left + box.width / 2 ? -1 : 1);
        }
        return;
      }
      go(dx < 0 ? 1 : -1);
    }
    stage.addEventListener('touchstart', down, { passive: true });
    stage.addEventListener('touchend', up, { passive: true });
    stage.addEventListener('mousedown', down);
    stage.addEventListener('mouseup', up);

    /* ⚠ DO NOT rely on the matchMedia 'change' event alone. Some renderers
       resize the viewport without dispatching it, and the book then stays in
       spread layout on a phone — where the left pane is display:none, so
       every even-numbered image (the leaf backs) becomes unreachable. */
    if (wide.addEventListener) wide.addEventListener('change', syncMode);
    else if (wide.addListener) wide.addListener(syncMode);
    var rq = false;
    var queueSync = function () {
      if (rq) return;
      rq = true;
      requestAnimationFrame(function () { rq = false; syncMode(); });
    };
    addEventListener('resize', queueSync, { passive: true });
    addEventListener('orientationchange', syncMode);
    if (typeof ResizeObserver !== 'undefined') new ResizeObserver(queueSync).observe(stage);
  }

  window.__twsMglBoot = initBook;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBook);
  else initBook();

  /* The theme editor swaps a section's HTML without reloading, so the new
     nodes carry no listeners and the book never stands. The data-mgl-built
     flag lives on the replaced element, so re-running is safe. */
  document.addEventListener('shopify:section:load', function () { initBook(); });
})();
